import React, { MouseEvent, ReactNode } from "react";
import cn from "classnames";
import {
    ButtonGroup,
    useButtonGroupState,
} from "@yandex-int/hr-components/ButtonGroup/bundle";
import { Button } from "./button/button";
import styles from "./select-button-group.module.scss";

interface SelectButtonGroupProps {
    className?: string;
    options: ISelectButtonGroupOption[];
    onChange?: (value: string) => void;
    selectedValue?: string;
    disabled?: boolean;
}

interface ISelectButtonGroupOption {
    value: string;
    content: ReactNode;
}

export const SelectButtonGroup: React.FC<SelectButtonGroupProps> = ({
                                                                        className,
                                                                        options,
                                                                        onChange,
                                                                        disabled,
                                                                        selectedValue
                                                                    }) => {
    const selectedValueIndex = options.findIndex((option) => option.value === selectedValue);
    const { onClick } = useButtonGroupState({ type: "radio" });

    const onButtonClick = (event: MouseEvent<any>, index: number) => {
        const selectedOption = options[index];
        onClick(event, index);
        if (onChange) {
            onChange(selectedOption.value);
        }
    }
    return (
        <ButtonGroup
            onClick={(event: MouseEvent<any>, index: number) => onButtonClick(event, index)}
            selected={[selectedValueIndex]}
            pin={options.length > 1 ? "round" : undefined}
            className={cn(styles.buttonGroup, className)}
        >
            {options.map(option => (
                <Button
                    disabled={disabled}
                    key={option.value}
                    view="legal_secondary"
                >
                    {option.content}
                </Button>
            ))}

        </ButtonGroup>
    );
};
